import { Injectable } from '@angular/core';
import { Sim } from '@ionic-native/sim';
import { Platform } from 'ionic-angular';
import { Messages } from '../../helpers/messages';
import { AlertServiceProvider } from '../alert-service/alert-service';


@Injectable()
export class SimProvider {

  constructor(
    private sim: Sim,
    private platform: Platform,
    private alertService: AlertServiceProvider
  ) { }

  async checkSimCard(): Promise<boolean> {
    if (this.platform.is('cordova')) {
      try {
        await this.platform.ready();
        const getSimInfo = await this.getSimInfo();
        console.log('getSimInfo', getSimInfo);
        if (getSimInfo && !getSimInfo.countryCode) {
          this.platform.backButton.subscribe(() => this.platform.exitApp());
          const options = {
            message: Messages.WARNING_FOR_USE_SIM_CARD,
            enableBackdropDismiss: false
          }

          await this.alertService.warningAlert(options);
          this.platform.exitApp();
          return false;
        }
      } catch (error) {
        console.log('error getSimInfo', error);
      }
    }

    return true;
  }

  async getSimInfo() {
    return this.sim.getSimInfo();
  }

  hasReadPermission() {
    return this.sim.hasReadPermission();
  }

  requestReadPermission() {
    return this.sim.requestReadPermission();
  }

}



// WEBPACK FOOTER //
// ./src/providers/sim/sim.service.ts